import { renderValue } from '../../helpers/renderValue';
import { TRenderRow } from '../../types/TRenderRow';

type TProps = {
  rows: TRenderRow[];
};

export function DataRows({ rows }: TProps) {
  return (
    <div className="grid gap-2">
      {rows.map((row) => (
        <div
          className="grid grid-cols-[150px_minmax(0,1fr)] items-start gap-2.5 text-[13px] leading-[18px] max-[860px]:grid-cols-1"
          key={row.label}
        >
          <span className="font-bold text-foreground-muted">{row.label}</span>
          <span className="whitespace-pre-wrap [overflow-wrap:anywhere] text-foreground">{renderValue(row.value)}</span>
        </div>
      ))}
    </div>
  );
}
